import { styled, useTheme } from "@mui/material/styles"
import { Box, IconButton } from "@mui/material"
import MuiDrawer from "@mui/material/Drawer"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"

import { drawerWidth, appBarHeight, closedDrawerWidth } from "@/config/layout"

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
})

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: closedDrawerWidth(theme),
  [theme.breakpoints.up("sm")]: {
    width: closedDrawerWidth(theme),
  },
})

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}))

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "openDrawer",
})(({ theme, open }) => ({
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open
    ? {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      }
    : {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      }),
  backgroundColor: "white",
}))

// Linke Navigationsleiste; children ist der Drawer-Inhalt (DrawerList).
export default function AppDrawer({ open, onClose, children }) {
  const theme = useTheme()

  return (
    <Drawer
      variant="permanent"
      open={open}
      slotProps={{ paper: { sx: { borderRight: "none" } } }}
    >
      <DrawerHeader sx={{ height: appBarHeight, backgroundColor: "white" }}>
        <IconButton sx={{ color: "white" }} onClick={onClose}>
          {theme.direction === "rtl" ? (
            <ChevronRightIcon sx={{ color: "#004f7d" }} />
          ) : (
            <ChevronLeftIcon sx={{ color: "#004f7d" }} />
          )}
        </IconButton>
      </DrawerHeader>
      <Box
        data-tour="drawer"
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          height: `calc(100vh - ${appBarHeight}px)`,
          width: "100%",
          backgroundColor: "#004f7d",
        }}
      >
        {/* clip statt hidden: nichts horizontal scrollbar, sonst schiebt driver.js' scrollIntoView die Leiste */}
        <Box sx={{ overflow: "clip" }}>{children}</Box>
      </Box>
    </Drawer>
  )
}
